export default __webpack_public_path__ + "static/media/sus_1.292a9a7c.webp";